'use strict';

function config(usSpinnerConfigProvider) {
    usSpinnerConfigProvider.setTheme('table', {
          lines: 13  // number of lines to draw
        , length: 4  // length of each line
        , width: 2   // line thickness
        , radius: 4  // radius of the inner circle
    });

    usSpinnerConfigProvider.setTheme('general', {
          lines: 13  // number of lines to draw
        , length: 9  // length of each line
        , width: 5   // line thickness
        , radius: 13 // radius of the inner circle
        , scale: 1   // scales overall size of the spinner
        , corners: 1 // corner roundness (0..1)
    });
}

config.$inject = ['usSpinnerConfigProvider'];
module.exports = config;


/** WEBPACK FOOTER **
 ** ./src/pages/services/spinnerconfig.js
 **/